import {
	RequestCompleteEntityState,
	RequestCompleteListState
}                      from '@core/interfaces/api.interface';
import { EntityState } from '@ngrx/entity';
import {
	Action,
	ActionCreator,
	NotAllowedCheck
}                      from '@ngrx/store/src/models';
import { Observable }  from 'rxjs';

// PROBABLY DELETABLE #######################################################
export type BaseAction<A, B, C> = {
	detailPage?: A;
	listPage?: B;
	modal?: C;
};

export interface State<T> extends EntityState<T> {
	storeEvent: string;

	requestCompleteState: RequestCompleteListState<T> | RequestCompleteEntityState<T>;
}

// KEEP #######################################################
export type ActionTypeWithProps<P extends object> = ActionCreator<any, ( props: P & NotAllowedCheck<P> ) => P & Action<any>>;
export type ActionType = ActionCreator<any, () => Action<any>>;

export type SelectorWithProps<S, P extends object, R> = ( state: S, props: P ) => R;
export type Selector<T, V> = ( state: T ) => V;


export enum StoreActionsEnum {
	ADD_MANY = 'add many',
	ADD_ONE = 'add one',
	SET_ALL = 'set all',
	SET_ONE = 'set one',
	UPSERT_MANY = 'upsert many',
	UPSERT_ONE = 'upsert one',
	UPDATE_MANY = 'update many',
	UPDATE_ONE = 'update one',
	REMOVE_ALL = 'remove all',
	REMOVE_MANY = 'remove many',
	REMOVE_ONE = 'remove one',
	MAP_ENTITY = 'map entity',
}


export interface IStoreConfig {
	caller?: string;
	getFromStoreFirst?: boolean;
	storeAction?: StoreActionsEnum;
	updateStore?: boolean;
}


export interface IStoreProcessingConfig<T> {
	selector?: Observable<T>;

	updater?: StoreActionsEnum;

	caller?: string;
}


export interface AdapterState<T> {
	adapter?: EntityState<T>;
}


